import React from 'react';
import t from 'prop-types';

var Precarga = function Precarga(_ref) {
  var style = _ref.style;
  return React.createElement('div', {
    className: 'contenedorPrecarga',
    style: style
  }, React.createElement('div', {
    className: 'cajaRotando num1'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num2'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num3'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num4'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num5'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num6'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num7'
  }, React.createElement('div', {
    className: 'bola'
  })), React.createElement('div', {
    className: 'cajaRotando num8'
  }, React.createElement('div', {
    className: 'bola'
  })));
};

Precarga.propTypes = process.env.NODE_ENV !== "production" ? {
  style: t.object
} : {};
export default Precarga;